module.exports = __webpack_public_path__ + "img/content_1_QualitySelection.2ce7ea97.png";